export enum InputValueReplaceStrategy {
	KEEP_INPUT_VALUE,
	REPLACE_WITH_SELECTED_VALUE,
}
